import React from 'react';

import {ReactComponent as AllGamesIcon} from "../images/icons/allGames.svg";
import {ReactComponent as Favorite} from "../images/icons/favorite.svg";

import img1 from '../images/cards/liveCasino/card-1.jpg'


export const LiveCasinoDB = [
  {
    image: img1,
    name: 'Live casino',

  },
  {
    image: img1,
    name: 'Live casino',

  },
  {
    image: img1,
    name: 'Live casino',

  },
  {
    image: img1,
    name: 'Live casino',

  },
  {
    image: img1,
    name: 'Live casino',

  },
  {
    image: img1,
    name: 'Live casino',

  },
  {
    image: img1,
    name: 'Live casino',

  },
  {
    image: img1,
    name: 'Live casino',

  },
]
